module.exports = __webpack_public_path__ + "static/media/A_Long_Trip.0fae8148.mp3";